import { QueryConfig } from "store/utils/query-config";

export const qcResultsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-checkedAt"],
  },
};
